import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getHighRiskSupplementsList } from '@api/highRiskSupplements';
import { IRiskSupplementsTableData } from '@interfaces/highRiskSupplements';

import { buildHighRiskSupplementsListPayload } from './utils';

export const handleGetHighRiskSupplementsList = createAsyncThunk<
  AxiosResponse<IRiskSupplementsTableData>,
  any
>('getHighRiskSupplementsList', props =>
  getHighRiskSupplementsList(buildHighRiskSupplementsListPayload(props)),
);
